// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SmartTextareaInput":"bgr_a bic_ve bic_vr bic_xh bic_vj"};